import { render, staticRenderFns } from "./Lisence.vue?vue&type=template&id=9c097a7c&scoped=true"
import script from "./Lisence.vue?vue&type=script&lang=js"
export * from "./Lisence.vue?vue&type=script&lang=js"
import style0 from "./Lisence.vue?vue&type=style&index=0&id=9c097a7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c097a7c",
  null
  
)

export default component.exports